import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchComponent } from './search.component';
import { TranslateModule } from '@xref/ngx';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatButtonModule } from '@angular/material/button';
import { CategoryIconModule } from '../category-icon/category-icon.module';
import { defaultPageScrollConfig, NGXPS_CONFIG } from 'ngx-page-scroll-core';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    FontAwesomeModule,
    MatButtonModule,
    CategoryIconModule,
    FormsModule
  ],
  exports: [SearchComponent],
  declarations: [SearchComponent],
  providers: [
    {provide: NGXPS_CONFIG, useValue: defaultPageScrollConfig}
  ]
})
export class SearchModule {}
